import { SpaceSettingsPage } from "../settings/SpaceSettingsPage";

/**
 * `spaces/:spaceId/edit/permission`: the one settings page (board `Ark-Settings`), scrolled to Permissions. Kept under the old name so
 * the routing module needs no change; the section itself is `settings/PermissionsSection` + `settings/LockedPagesSection`.
 */
export function PermissionPage() {
    return <SpaceSettingsPage focus="permissions" />;
}
